import type { FC } from "react";

import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { PackageCrossIcon } from "@jti/brand-icons/package-cross";

import styles from "./OutOfStock.module.scss";

type OutOfStockProps = {
  className?: string;
  hideIcon?: boolean;
};

export const OutOfStock: FC<OutOfStockProps> = ({ className, hideIcon }) => {
  const { __ } = useTranslations();
  return (
    <div className={classNames(className, styles.outOfStockContainer)} data-testid="outOfStockContainer">
      <div className={styles.circle}></div>
      {!hideIcon && <PackageCrossIcon data-testid="outOfStock-icon" className={styles.icon} />}
      <div className={styles.outOfStockLabel}>{__("libs.ui.out_of_stock.title")}</div>
    </div>
  );
};
